import { useState } from "react";
import { IconColorE, UserRoleE } from "../../../../models/enums";
import Icon from "../../../../components/Icon/Icon";
import { P, Span } from "../../../../components/Text/Text";
import BottomSlider from "../../../../components/BottomSlider/BottomSlider";
import SupportForm from "../SupportForm/SupportForm";
import { useNavigate } from "react-router-dom";
import { RoutesE } from "../../../../routes/routesData";
import { useAppSelector } from "../../../../store/hooks";
import { selectCurrentUser } from "../../../../store/selectors/authSelectors";

import styles from "./contactsInfo.module.scss";

const ContactsInfo = () => {
  const navigate = useNavigate();
  const [showContactForm, setShowContactForm] = useState(false);
  const iconColor = IconColorE.DARK_GRAY;
  const user = useAppSelector(selectCurrentUser);

  const toggleContactForm = () => {
    setShowContactForm((prev) => !prev);
  };

  const navigateToHelp = () => {
    navigate(RoutesE.HELP);
  };

  return (
    <div>
      <div className={styles.sectionHeader}>
        <Icon name="envelope" color={iconColor} />
        <Span>Email:</Span>
      </div>
      <div className={styles.section}>
        <a href="mailto:media@jumbomail.me">media@jumbomail.me</a>
      </div>
      <div className={styles.sectionHeader}>
        <Icon name="phone" color={iconColor} />
        <Span>Phone:</Span>
      </div>
      <div className={styles.section}>
        <div className={styles.phoneNumberWrapper}>
          <Span>Text us on WhatsApp: </Span>
          <a
            href="https://wa.me/972509067644"
            target="_blank"
            rel="noopener noreferrer"
          >
            +972 50-906-7644
          </a>
     
        </div>
        <P>In urgent cases out of the working hours, you can contact us at:</P>
        <div className={styles.phoneNumberWrapper}>
          <Span>Efrat: </Span>
          <a href="tel:+972772170170">+972-77-2170170 (Ext. 6)</a>
        </div>
        <div className={styles.phoneNumberWrapper}>
          <Span>Eran: </Span>
          <a href="tel:+972523528240">+972-52-3528240</a>
        </div>
        <div className={styles.phoneNumberWrapper}>
          <Span>Shahar: </Span>
          <a href="tel:+972523613000">+972-52-3613000</a>
        </div>
      </div>
      <div className={styles.sectionHeader}>
        <Icon name="clock" color={iconColor} />
        <Span>Working hours:</Span>
      </div>
      <div className={styles.section}>
        <P>09:30-17:00</P>
        {user.role === UserRoleE.DeliveryService && (
          <p className={styles.note}>
            <Span className={styles.noteTitle}>Note: </Span>
            <Span>
              Campaigns that will be sent after 17:00 will be confirmed in the
              day after
            </Span>
          </p>
        )}
      </div>
      {/* <AccessRights
        accessFor={[UserRoleE.PostProduction, UserRoleE.DeliveryService]}
      >
        <NavLink
          to={RoutesE.POST_PRODUCTION_PRICE_CALC}
          className={styles.pricingCalcLink}
        >
          <Icon name="calc" color={iconColor} />
          <Span>Pricing Calculator</Span>
        </NavLink>
      </AccessRights> */}
      {/* <div className={styles.mobileSection}>
        <p>
          <Span className={styles.contactButton} onClick={toggleContactForm}>
            Contact us
          </Span>
          <Span> for any question.</Span>
        </p>
        <p>
          <Span>For technical instructions</Span>{" "}
          <Span className={styles.contactButton} onClick={navigateToHelp}>
            click here
          </Span>
          .
        </p>
      </div> */}
      <BottomSlider
        visible={showContactForm}
        onClose={toggleContactForm}
        title="Contact us"
      >
        <SupportForm />
      </BottomSlider>
    </div>
  );
};

export default ContactsInfo;
